module.exports = __webpack_public_path__ + "static/img/a104.406ae4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a104.jpg
// module id = p9n3
// module chunks = 0